import api from './api';

const concesionariaVentaProduccionService = {
  getMeta() {
    return api.get('/produccion-concesionaria/venta-produccion/meta').then((r) => r.data);
  },
  getPlantillasCatalog() {
    return api.get('/produccion-concesionaria/venta-produccion/plantillas-catalog').then((r) => r.data);
  },
  getPlantillas(pointOfSaleId) {
    return api
      .get(`/produccion-concesionaria/venta-produccion/plantillas/${pointOfSaleId}`)
      .then((r) => r.data);
  },
  createPlantilla(pointOfSaleId, data) {
    return api
      .post(`/produccion-concesionaria/venta-produccion/plantillas/${pointOfSaleId}`, data)
      .then((r) => r.data);
  },
  updatePlantilla(plantillaId, data) {
    return api
      .put(`/produccion-concesionaria/venta-produccion/plantillas/item/${plantillaId}`, data)
      .then((r) => r.data);
  },
  deletePlantilla(plantillaId) {
    return api
      .delete(`/produccion-concesionaria/venta-produccion/plantillas/item/${plantillaId}`)
      .then((r) => r.data);
  },
  getPlantillaDashboard(plantillaId, params = {}) {
    return api
      .get(`/produccion-concesionaria/venta-produccion/plantillas/${plantillaId}/dashboard`, { params })
      .then((r) => r.data);
  },
  getDashboardGeneral(params = {}) {
    return api
      .get('/produccion-concesionaria/venta-produccion/dashboard/general', { params })
      .then((r) => r.data);
  },
  getDashboardPos(pointOfSaleId, params = {}) {
    return api
      .get(`/produccion-concesionaria/venta-produccion/dashboard/pos/${pointOfSaleId}`, { params })
      .then((r) => r.data);
  },
  getDashboardCompare(params = {}) {
    return api
      .get('/produccion-concesionaria/venta-produccion/dashboard/compare', { params })
      .then((r) => r.data);
  },
  getColumnas(plantillaId) {
    return api
      .get(`/produccion-concesionaria/venta-produccion/plantillas/${plantillaId}/columnas`)
      .then((r) => r.data);
  },
  saveColumnas(plantillaId, columns) {
    return api
      .put(`/produccion-concesionaria/venta-produccion/plantillas/${plantillaId}/columnas`, { columns })
      .then((r) => r.data);
  },
  getServiciosComida(pointOfSaleId) {
    return api
      .get(`/produccion-concesionaria/venta-produccion/servicios-comida/${pointOfSaleId}`)
      .then((r) => r.data);
  },
  getServiciosVentaPos(pointOfSaleId) {
    return api
      .get(`/produccion-concesionaria/venta-produccion/servicios-venta-pos/${pointOfSaleId}`)
      .then((r) => r.data);
  },
  saveServiciosComida(pointOfSaleId, services) {
    return api
      .put(`/produccion-concesionaria/venta-produccion/servicios-comida/${pointOfSaleId}`, { services })
      .then((r) => r.data);
  },
  getSheetsHistory(params) {
    return api
      .get('/produccion-concesionaria/venta-produccion/sheets-history', { params })
      .then((r) => r.data);
  },
  getSheet(params) {
    return api.get('/produccion-concesionaria/venta-produccion/sheets', { params }).then((r) => r.data);
  },
  saveSheet(payload) {
    return api.put('/produccion-concesionaria/venta-produccion/sheets', payload).then((r) => r.data);
  },
  confirmSheet(sheetId) {
    return api
      .post(`/produccion-concesionaria/venta-produccion/sheets/${sheetId}/confirmar`)
      .then((r) => r.data);
  },
  revertSheet(sheetId) {
    return api
      .post(`/produccion-concesionaria/venta-produccion/sheets/${sheetId}/revertir`)
      .then((r) => r.data);
  },
};

export default concesionariaVentaProduccionService;
